import { CircularProgress, Grid, Paper, Typography } from '@mui/material';

import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { ProfileStatistics } from '../../models/profileStatistics';
import { leaveManageApiKeyStore } from '../../api/leave-manage-api-key-store';

const styling = {
  paperStyle: { padding: '30px 20px 10px', borderRadius: '10px' },
  countStyle: { color: '#0000b5', fontSize: 50 },
};

interface ComponentCell {
  label: string;
  value: any;
  isLoading: boolean;
}
const ComponentCell = ({ label, value, isLoading }: ComponentCell) => {
  return (
    <Paper elevation={0} style={styling.paperStyle}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item display={'flex'}>
          <Grid container justifyContent="flex-start" alignItems="flex-end">
            <Typography variant="body1" color="text.secondary">
              {label}
            </Typography>
          </Grid>
        </Grid>
        <Grid item display={'flex'}>
          <Grid container justifyContent="flex-end" alignItems="flex-end">
            {!isLoading ? (
              <Typography variant="h4" style={styling.countStyle}>
                {value}
              </Typography>
            ) : (
              <CircularProgress />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export const LeaveManageStatics = () => {
  const { data, isLoading } = useLoadData<ApiResponse<ProfileStatistics>>(
    leaveManageApiKeyStore.getLeaveRequestCount()
  );

  return (
    <Grid container spacing={2} className="detailsBoxContainer">
      <Grid item lg={3} sm={3} xl={3} xs={3} className="detailsBox">
        <ComponentCell label="APPROVED" value={data?.data.approvedCount} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3} className="detailsBox">
        <ComponentCell label="REJECTED" value={data?.data.rejectedCount} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3} className="detailsBox">
        <ComponentCell label="PENDING" value={data?.data.pendingCount} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3} className="detailsBox">
        <ComponentCell label="TOTAL REQUESTS" value={data?.data.totalCount} isLoading={isLoading} />
      </Grid>
    </Grid>
  );
};
